import { z } from 'zod';

import { ZodCurrency } from '@Common/types/Amount';
import { ZodId } from '@Common/types/request';

export const ZodGetEmployeeBalanceResponse = z.object({
  id: ZodId,
  withdrawable_balance: z.number(),
  booked_in_orders: z.number(),
  total_balance: z.number(),
  locked_balance: z.number(),
  unsettled_balance: z.number(),
  user_id: ZodId,
  currency: ZodCurrency,
});
export type GetEmployeeBalanceResponse = z.TypeOf<typeof ZodGetEmployeeBalanceResponse>;
